import { createSlice } from '@reduxjs/toolkit'
import { IAuth } from 'src/utils/Interfaces/state.interface'

const initialState: IAuth = {
  role: null,
  name: null,
  id: null,
  avatar: null,
  position: null
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { name, role, id, avatar, position } = action.payload
      state.name = name
      state.role = role
      state.id = id
      state.avatar = avatar
      state.position = position
    },
    logOut: (state) => {
      state.name = null
      state.role = null
      state.id = null
      state.avatar = null
      state.position = null
    }
  },
  selectors: {
    getRole: (state) => state.role,
    getPosition: (state) => state.position,
    getNameID: (state) => {
      return { name: state.name, id: state.id }
    },
    getAvatar: (state) => state.avatar
  }
})

export const { setCredentials, logOut } = authSlice.actions

export const { getNameID, getRole, getAvatar, getPosition } = authSlice.selectors

export default authSlice.reducer
